export default "__VITE_ASSET__CfI9hMo$__"